/* eslint-disable no-underscore-dangle */
/* eslint-disable space-in-parens */
/* eslint-disable react/prop-types */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import Cookie from 'cookie-universal';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { ChromePicker } from 'react-color';
import userActions from '../../../redux/actions/userActions';
import languageService from '../../../redux/services/languageServices';
import { getFlagWithTextReverse } from '../../../helpers/flagDisplay';
import userServices from '../../../redux/services/userServices';

const cookies = Cookie();

const useStyles = makeStyles(() => ({
  menu: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexGrow: 1,
  },
  displayName: {
    color: '#FFF',
  },
}));

const TopbarMenuLinks = (props) => {
  const { user, color, setColor } = props;
  const classes = useStyles();
  const [redirectLogin, setredirectLogin] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const [colorMenu, setcolorMenu] = useState(null);
  const [language, setlanguage] = useState([]);

  useEffect(() => {
    languageService.getAll()
      .then((res) => {
        setlanguage(res);
      });
  }, []);

  const logout = () => {
    props.logout();
    setredirectLogin(true);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickcolor = (event) => {
    setcolorMenu(event.currentTarget);
    setAnchorEl(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setcolorMenu(null);
  };

  const handleChangeColor = (col) => {
    const newCol = { ...col.rgb };
    newCol.a = col.rgb.a / 2;
    userServices.updateUser(user._id, user.type, JSON.stringify({ themeColor: newCol }))
      .then(() => {
        props.getUser(user._id, false);
        props.getUser(user._id, true);
      });
    setColor(newCol);
  };

  const changeLanguage = (initial) => {
    cookies.set('language', initial);
    window.location.reload();
    handleClose();
  };

  if (redirectLogin) {
    return (
      <Redirect to="/" />
    );
  }
  let userDisplay = '';
  if (user) userDisplay = `${user.name} ${user.firstname}`;

  const lang = [];
  if (language.length > 0) {
    language.forEach((elem) => {
      lang.push(
        <MenuItem key={elem._id} onClick={() => changeLanguage(elem.initial)}>
          {getFlagWithTextReverse(elem)}
        </MenuItem>,
      );
    });
  }
  return (
    <>
      <div className={classes.menu}>
        <IconButton
          aria-label="more"
          aria-controls="menu-profil"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon style={{ color: '#FFF' }} />
        </IconButton>
      </div>
      <Menu
        id="menu-color"
        anchorEl={colorMenu}
        keepMounted
        style={{ zIndex: 29 }}
        open={Boolean(colorMenu)}
        onClose={handleClose}
      >
        <ChromePicker
          style={{ zIndex: 29 }}
          color={{
            r: color.r, g: color.g, b: color.b, a: color.a * 2,
          }}
          onChangeComplete={handleChangeColor}
        />
      </Menu>
      <Menu
        id="menu-profil"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <p
          className={classes.displayName}
          style={{
            color: 'black', fontWeight: 'bold', marginLeft: 10, marginRight: 10,
          }}
        >
          {`${userDisplay}`}
        </p>
        <MenuItem onClick={handleClickcolor}>Colors</MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

TopbarMenuLinks.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.any.isRequired,
};

function mapState(state) {
  const { user } = state.user;
  return { user };
}

const actionCreators = {
  logout: userActions.logout,
  getUser: userActions.getUser,
};

const connectedTopbarMenu = connect(mapState, actionCreators)(TopbarMenuLinks);
export default connectedTopbarMenu;
